import React from 'react';
import './ThresholdInput.scss';
import { InputComponent } from '../../../../ReusableComponents/Input/InputComponent';
import { ValueBasedDiscount } from '../storeTypes';
import { FaTrash } from 'react-icons/fa';
import { ButtonComponent } from '../../../../ReusableComponents/Button/ButtonComponent';
import { ThresholdErrorField } from '../EditStoreSettings';
import { InputType } from './ThresholdInput';

interface Props {
  valueBasedDiscount: ValueBasedDiscount;
  onChange: (value: string, index: number, inputType: InputType) => void;
  onClickDelete: (deleteIndex: number) => void;
  index: number;
  errorField?: ThresholdErrorField;
}

const SingleThresholdInput = ({
  valueBasedDiscount,
  onChange,
  onClickDelete,
  index,
  errorField,
}: Props) => {
  return (
    <div>
      <div className="threshold__input">
        <InputComponent
          variant="outlined"
          data-lpignore="true"
          label="Threshold"
          size="small"
          id="threshold"
          name="threshold"
          type="number"
          value={valueBasedDiscount.threshold}
          error={errorField?.threshold}
          onChange={event => onChange(event.target.value, index, 'threshold')}
        />
      </div>
      <div className="threshold__input">
        <InputComponent
          className="threshold__input"
          variant="outlined"
          data-lpignore="true"
          label="Discount"
          size="small"
          id="discount"
          name="discount"
          type="number"
          value={valueBasedDiscount.discount}
          error={errorField?.discount}
          onChange={event => onChange(event.target.value, index, 'discount')}
        />
      </div>
      <ButtonComponent
        variant="outlined"
        startIcon={<FaTrash />}
        onClick={() => onClickDelete(index)}
      >
        {'Remove'}
      </ButtonComponent>
    </div>
  );
};

export default SingleThresholdInput;
